import { connect } from 'react-redux';

import {
  getDisabledQuestions,
  getFavoriteQuestions,
  removeAllFavoriteQuestions,
  removeFavoriteQuestions,
  resetAllDisabledQuestions,
  resetDisabledIndividualQuestion,
  resetDisabledQuestionObject,
  resetFavoriteQuestionObject,
  setDisabledQuestionsCount,
  setFavoriteQuestionsCount,
  successResetIndividualQuestion,
} from '../../actions/accountSettingsAction';
import {
  disabledQuestionsCountSelector,
  disabledQuestionsSelector,
  favoriteQuestionsCountSelector,
  favoriteQuestionsSelector,
  isLoadingDisabledQuestionsSelector,
  isLoadingResetAllSelector,
  isLoadingResetIndividualQuestionSelector,
  loadingFavoriteQuestionsSelector,
  loadingRemoveFavoriteQuestionsSelector,
  successDisabledQuestionsSelector,
  successResetAllSelector,
  successResetIndividualQuestionSelector,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import DisabledOrFavoriteQuestions from '../../components/AccountSettings/DisabledOrFavoriteQuestions/DisabledOrFavoriteQuestions';

const mapStateToProps = (state, ownProps) => ({
  isLoadingResetAll: isLoadingResetAllSelector(state),
  isLoadingResetIndividualQuestion:
    isLoadingResetIndividualQuestionSelector(state),
  isLoadingDisabledQuestions: isLoadingDisabledQuestionsSelector(state),
  successGetDisabledQuestions: successDisabledQuestionsSelector(state),
  successResetAll: successResetAllSelector(state),
  successResetIndividualQuestion: successResetIndividualQuestionSelector(state),
  disabledQuestions: disabledQuestionsSelector(state),
  disabledQuestionsCount: disabledQuestionsCountSelector(state),
  favoriteQuestions: favoriteQuestionsSelector(state),
  favoriteQuestionsCount: favoriteQuestionsCountSelector(state),
  loadingFavoriteQuestions: loadingFavoriteQuestionsSelector(state),
  loadingRemoveFavoriteQuestions: loadingRemoveFavoriteQuestionsSelector(state),
});
const mapDispatchToProps = (dispatch) => ({
  getDisabledQuestions: (limit, skip) => {
    dispatch(getDisabledQuestions(limit, skip));
  },
  resetAllDisabledQuestions: () => {
    dispatch(resetAllDisabledQuestions());
  },
  resetDisabledIndividualQuestion: (questionId) => {
    dispatch(resetDisabledIndividualQuestion(questionId));
  },
  resetDisabledQuestionObject: () => {
    dispatch(resetDisabledQuestionObject());
  },
  resetFavoriteQuestionObject: () => {
    dispatch(resetFavoriteQuestionObject());
  },
  removeAllFavoriteQuestions: () => {
    dispatch(removeAllFavoriteQuestions());
  },
  setDisabledQuestionsCount: (count) => {
    dispatch(setDisabledQuestionsCount(count));
  },
  setFavoriteQuestionsCount: (count) => {
    dispatch(setFavoriteQuestionsCount(count));
  },
  successResetIndividualQuestion: (success) => {
    dispatch(successResetIndividualQuestion(success));
  },
  getFavoriteQuestions: (limit, skip) => {
    dispatch(getFavoriteQuestions(limit, skip));
  },
  removeFavoriteQuestions: (userId, questionsId) => {
    dispatch(removeFavoriteQuestions(userId, questionsId));
  },
});

const DisabledQuestionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DisabledOrFavoriteQuestions);

export default DisabledQuestionsContainer;
